module.exports = __webpack_public_path__ + "img/Infografis_ID_15.edeaf769.jpg";